import { apiGet, apiPatch, apiPost } from './client.js';

export interface UserListItem {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  storeIds?: string[] | null;
  active?: boolean;
}

export function listUsers() {
  return apiGet<UserListItem[]>('/api/v1/users').then((res) => res.data);
}

export function createUser(body: Record<string, unknown>) {
  return apiPost<UserListItem, Record<string, unknown>>('/api/v1/users', body).then(
    (res) => res.data,
  );
}

export function updateUser(id: string, body: Record<string, unknown>) {
  return apiPatch<UserListItem, Record<string, unknown>>(`/api/v1/users/${id}`, body).then(
    (res) => res.data,
  );
}
